import {
  DEFAULT_MIVO_LOCALE,
  LOCALE_STORAGE_KEY,
  type MivoTranslationKey,
  MIVO_LOCALES,
} from "./ITranslation";
import { resolveTranslationLanguage } from "./localeNormalization";
import { clearLocaleCookie, readLocaleCookie, writeLocaleCookie } from "./localeCookie";

export function isMivoTranslationKey(value: string | null | undefined): value is MivoTranslationKey {
  return value != null && (MIVO_LOCALES as readonly string[]).includes(value);
}

export function normalizeStoredLocale(value: string | null | undefined): MivoTranslationKey {
  if (isMivoTranslationKey(value)) {
    return value;
  }
  return resolveTranslationLanguage(value);
}

/** Anonymous init order: cookie → localStorage → default (BR-07). */
export function resolveInitialLocale(): MivoTranslationKey {
  const fromCookie = readLocaleCookie();
  if (fromCookie) {
    return fromCookie;
  }
  return readStoredLocale();
}

export function readStoredLocale(): MivoTranslationKey {
  if (typeof window === "undefined") {
    return DEFAULT_MIVO_LOCALE;
  }

  try {
    return normalizeStoredLocale(window.localStorage.getItem(LOCALE_STORAGE_KEY));
  } catch {
    return DEFAULT_MIVO_LOCALE;
  }
}

export function writeStoredLocale(locale: MivoTranslationKey): void {
  if (typeof window === "undefined") {
    return;
  }

  const normalized = normalizeStoredLocale(locale);

  try {
    window.localStorage.setItem(LOCALE_STORAGE_KEY, normalized);
  } catch {
    /* ignore quota / private mode */
  }

  writeLocaleCookie(normalized);
}

export function clearStoredLocale(): void {
  if (typeof window === "undefined") {
    return;
  }

  try {
    window.localStorage.removeItem(LOCALE_STORAGE_KEY);
  } catch {
    /* ignore */
  }

  clearLocaleCookie();
}
